export default [
  // *===============================================---*
  // *--------- MANAGER ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/specialists/list',
    name: 'pages-specialists-list',
    component: () => import('@/views/pages/specialist/SpecialistList.vue'),
    meta: {
      action: 'read',
      resource: 'manager',
      required: true,
    },
  },
]
